import { render } from "./commessaAdd.vue?vue&type=template&id=0869de6e"
import script from "./commessaAdd.vue?vue&type=script&lang=js"
export * from "./commessaAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__